import React, { useEffect, useState } from "react";
import {
  ModalOverlay,
  ModalContent,
  Title,
  Table,
  TableHeader,
  TableRow,
  TableCell,
  CloseButton,
} from "./ReservationStatusPopup.styles";
import Pagination from "../../../components/web/Pagination";
import { Reservation } from "./ReservationStatusPopup.types";

const ITEMS_PER_PAGE = 10;

export interface ReservationStatusPopupProps {
  isOpen: boolean;
  onClose: () => void;
  id: string;
  totalReservations: number;
  currentList: Reservation[];
}

const ReservationStatusPopup = ({
  id,
  isOpen,
  onClose,
  totalReservations,
  currentList,
}: ReservationStatusPopupProps) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [reservations, setReservations] = useState<Reservation[]>([]);
  const [pageList, setPageList] = useState<Reservation[]>([]);
  useEffect(() => {
    setCurrentPage(1);
    setTotalPages(Math.floor(currentList.length / ITEMS_PER_PAGE) + 1);
    setReservations(currentList);
  }, [currentList]);

  useEffect(() => {
    setPageList(
      reservations.slice(
        (currentPage - 1) * ITEMS_PER_PAGE,
        currentPage * ITEMS_PER_PAGE
      )
    );
  }, [reservations, currentPage]);
  if (!isOpen) return null;

  return (
    <ModalOverlay onClick={onClose}>
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <div className="header">
          <Title>예약 현황({totalReservations}명)</Title>
          <CloseButton onClick={onClose}>&times;</CloseButton>
        </div>
        <Table>
          <thead>
            <tr>
              <TableHeader>NO.</TableHeader>
              <TableHeader>닉네임</TableHeader>
            </tr>
          </thead>
          <tbody>
            {pageList.map((reservation: Reservation, index: number) => (
              <TableRow key={reservation.id}>
                <TableCell>
                  {reservations.length -
                    reservations.findIndex((item) => item === pageList[index])}
                </TableCell>
                <TableCell>{reservation.nickname}</TableCell>
              </TableRow>
            ))}
          </tbody>
        </Table>
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={setCurrentPage}
          size={22}
        ></Pagination>
      </ModalContent>
    </ModalOverlay>
  );
};

export default ReservationStatusPopup;
